import React from 'react';
import Grid from './grid';
import SearchResults from './search-results';

export default function GridNavigation(): React.ReactElement {
  return (
    <Grid wrapperOnly>
      <div className="col col-6">
        <SearchResults />
      </div>
    </Grid>
  );
}
